/// <amd-module name="Pipeline/Analytics/PipelineOutcome/FailedRunsCard/Actions/PipelineOutcomeFailedRunsActions" />
import { PipelineReportBaseActions } from "Pipeline/Analytics/Common/Actions/PipelineReportBaseActions";
import { IStageMetrics } from "Pipeline/Analytics/Common/Types";
import { IPipelineOutcomeTaskFailureData } from "Pipeline/Analytics/PipelineOutcome/Common/Types";
import { Action } from "VSS/Reflux/Action";

export class PipelineOutcomeFailedRunsActions extends PipelineReportBaseActions<IPipelineOutcomeTaskFailureData[]> {
    public initializeStagesAction: Action<IStageMetrics[]> = new Action<IStageMetrics[]>();
    public selectStageAction: Action<string> = new Action<string>();
}
